import { theme } from '../../Theme';
import { css } from 'emotion';

export const EztradStyling = css`
  .category-header {
    h1 {
      font-weight: 700;
      font-size: 2.75rem;
      color: ${theme.colors.black};
      text-transform: uppercase;
      font-feature-settings: normal;
    }
    .category-description {
      line-height: 171%;
      letter-spacing: 0.03em;
    }
  }

  .show-more-button a {
    color: ${theme.colors.almostBlack};
    border-color: ${theme.colors.black};
    text-transform: none;
    font-variant: normal;
    font-size: 0.875rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    font-feature-settings: 'liga' off;
  }

  .filters-list [data-flight-dropdown],
  .filters-list > div {
    button[data-flight-dropdown-button],
    > button {
      text-transform: none;
      font-variant: normal;
      font-weight: 700;
      font-size: 0.875rem;
      letter-spacing: 0.03em;
      font-feature-settings: 'liga' off;
    }

    ul[data-flight-dropdown-items] li[data-flight-dropdown-item]:hover,
    > div > div > button:hover {
      background-color: ${theme.colors.lightGrey};
    }
  }

  .active-filters {
    .active-filter {
      font-weight: 700;
      font-size: 0.875rem;
      letter-spacing: 0.03em;
      font-feature-settings: 'liga' off;
      background-color: ${theme.colors.lightGrey};
      .close-container {
        background-color: ${theme.colors.lightGrey};
      }
      :hover .close-container {
        background-color: ${theme.colors.softGrey};
      }
    }
    .clear-button-container {
      margin: 0 0.375rem 0.375rem;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        font-weight: 700;
        font-size: 0.875rem;
        letter-spacing: 0.03em;
        font-feature-settings: 'liga' off;
        color: ${theme.colors.almostBlack};
      }
    }
  }

  .mobile-filter-button {
    text-transform: none;
    font-variant: normal;
    border-color: ${theme.colors.mediumGrey};
    color: ${theme.colors.black};
    font-weight: 700;
    font-size: 0.875rem;
    letter-spacing: 0.03em;
  }

  .sort-filter-drawer {
    background-color: ${theme.colors.lightGrey};
    .header {
      border-top: none;
      border-color: ${theme.colors.mediumGrey};
      h1 {
        font-weight: 700;
        font-size: 0.875rem;

        text-transform: uppercase;
        font-variant: normal;
        color: ${theme.colors.almostBlack};
      }
    }
    .sort-accordion button svg use {
      fill: ${theme.colors.almostBlack};
    }
  }

  .product-grid-window-container {
    .product-card {
      a {
        margin-bottom: 1.875rem;
      }
      .price {
        font-family: ${theme.fonts.secondary};
        font-feature-settings: normal;
        text-transform: uppercase;
        font-size: 1.25rem;
      }
    }
  }

  ${theme.below.md} {
    .category-header h1 {
      font-size: 2rem;
    }
  }
`;
